/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Systems_LabelInputs */

const en_common_systems_label = /** @type {(inputs: Common_Systems_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch System`)
};

const zh_common_systems_label = /** @type {(inputs: Common_Systems_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换系统`)
};

/**
* | output |
* | --- |
* | "Switch System" |
*
* @param {Common_Systems_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_systems_label = /** @type {((inputs?: Common_Systems_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Systems_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_systems_label(inputs)
	return zh_common_systems_label(inputs)
});
export { common_systems_label as "common.systems.label" }